__turbopack_context__.v({
  "button": "Dropdown-module-sass-module__CopyWq__button",
  "button__arrow": "Dropdown-module-sass-module__CopyWq__button__arrow",
  "button__count": "Dropdown-module-sass-module__CopyWq__button__count",
  "button__icon": "Dropdown-module-sass-module__CopyWq__button__icon",
  "button__remove": "Dropdown-module-sass-module__CopyWq__button__remove",
});
